import { FingerfoodService } from '../../services'

export const state = {
    fingerfood: []
}

export const actions = {
    fetchFingerfood({commit}) {
        FingerfoodService.getFingerfood()
            .then((fingerfood) => {
                commit('setFingerfood', fingerfood)
            })
            .catch((err) => {
                commit('setError', err)
            })

    },

}

export const mutations = {
    setFingerfood(state, fingerfood) {
        state.fingerfood = fingerfood
    },
    setError(state) {
        state.fingerfood = []
    }

}

export const getters = {
    fingerfood: ({ fingerfood }) => fingerfood,
}

export default {
    state,
    actions,
    mutations,
    getters
}